import React, { useEffect, useState, useRef } from 'react'
import { CAlert } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilBurn, cilCheckCircle, cilInfo, cilWarning } from '@coreui/icons'
import { useLocation } from 'react-router-dom'

const AlertNotification = () => {
    const [alert, setAlert] = useState(null);
    const [timeoutId, setTimeoutId] = useState(null);
    const location = useLocation();
    const isInitialMount = useRef(true);

    useEffect(() => {

        const checkForAlert = () => {
            const storedAlert = localStorage.getItem('globalAlert');
            if (storedAlert) {
                const { message, type } = JSON.parse(storedAlert);
                window.scrollTo(0, 0);
                setAlert({ message, type });
                localStorage.removeItem('globalAlert');
                isInitialMount.current = true;

                // Configura timeout para auto-dismiss
                const id = setTimeout(() => {
                    setAlert(null);
                }, 5000);
                setTimeoutId(id);
            }
        };

        checkForAlert();

        if (!isInitialMount.current) {
            handleDismiss();
        }

        isInitialMount.current = false;

        return handleDismiss;
    }, [location.key]);

    // useEffect(() => {
    //     if (isInitialMount.current) {
    //         isInitialMount.current = false;
    //         return;
    //     }
    //     handleDismiss();
    // }, []);

    const handleDismiss = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
        setAlert(null);
    };

    if (!alert) return null;

    const alertColor = {
        success: 'success',
        info: 'info',
        warning: 'warning',
        error: 'danger'
    }[alert.type];

    const alertIcon = {
        success: cilCheckCircle,
        info: cilInfo,
        warning: cilWarning,
        error: cilBurn
    }[alert.type];

    return (
        <>
            <CAlert color={alertColor} className="d-flex align-items-center" onClose={handleDismiss} dismissible>
                <CIcon icon={alertIcon} className="flex-shrink-0 me-2" width={24} height={24} />
                <div>{alert.message}</div>
            </CAlert>
        </>
    )
}

export default AlertNotification;

export const triggerAlert = (message, type = 'success') => {
    localStorage.setItem('globalAlert', JSON.stringify({ message, type }));
};